import HBButton from "@/components/HBButton";
import HBIcon from "@/components/HBIcon";
import Image from "@/components/Image";
import imageUrl from "@/utils/imageUrl";
import classNames from "classnames";
import { Else, If, Then, When } from "react-if";
import styles from "./index.module.less";

const iconMap = {
  time: "采集至画板",
  search: "",
};

interface IProps {
  board: (IBoardInfo & { _icon?: string }) | null;
  cover?: IPinFile & { is_private?: number };
  index?: number;
  activeIndex?: number;
  onSelect?: (boardId: number) => void;
  isRecommended?: boolean;
  isRelatedBoard?: boolean;
  onUserBoardUpdate?: (board: any) => void;
  searchWord?: string;
  isOnlyUnclassified?: boolean;
  renderActions?: (board: IBoardInfo) => React.ReactNode;
  hoverShowActions?: boolean;
  actionText?: string; // 自定义按钮文本，默认为"采集"或"创建并采集"
  actionButtonName?: string; // 自定义按钮的 data-button-name
  buttonTheme?: "black" | "gray"; // 按钮主题
}
export default function BoardItem({
  board,
  cover,
  index,
  activeIndex,
  onSelect,
  isRecommended = false,
  isRelatedBoard = false,
  onUserBoardUpdate,
  searchWord,
  isOnlyUnclassified = false,
  renderActions,
  hoverShowActions,
  actionText,
  actionButtonName,
  buttonTheme,
}: IProps) {
  // 确定按钮文本
  const buttonText = actionText || (isRelatedBoard ? "创建并采集" : "采集");
  // 确定按钮的 data-button-name
  const buttonName =
    actionButtonName || (isRelatedBoard ? "确定创建画板" : "确认采集");
  // 确定按钮类型和主题：批量移动使用黑色按钮，其他使用 primary
  const buttonType = buttonTheme === "black" ? "default" : "primary";
  return (
    <>
      {board?._icon && board._icon !== "unclassified" && (
        <div className={styles.splitText}>
          {iconMap[board._icon] || board._icon}{" "}
        </div>
      )}
      <div
        className={classNames([
          styles.item,
          activeIndex === index ? styles.active : null,
          hoverShowActions ? styles.hoverShowActions : null,
        ])}
        data-board-id={board?.board_id}
        data-gd-click="button_click"
        data-button-name={buttonName}
        onClick={async () => {
          if (isRelatedBoard && onUserBoardUpdate) {
            // 如果是推荐的同在画板，需要先创建画板
            const boardName = board?.title || "";
            if (boardName) {
              try {
                // 动态导入创建画板API
                const { createBoard } = await import("@/services");

                // console.log("开始创建并采集到推荐画板:", boardName);

                // 1. 创建画板
                const createResult = await createBoard({
                  title: boardName,
                });

                if (createResult.err) {
                  console.error("创建画板失败:", createResult.msg);
                  return;
                }

                // 2. 更新用户画板列表
                onUserBoardUpdate(createResult.board);

                // 3. 触发采集到新创建的画板
                onSelect(createResult.board.board_id);
              } catch (error) {
                console.error("创建并采集推荐画板失败:", error);
              }
            }
          } else {
            onSelect(board?.board_id);
          }
        }}
        data-search-word={searchWord}
        data-pin-detail
        data-index={index}
      >
        <div className={styles.content}>
          <div className={styles.left}>
            <div className={styles.img}>
              <If condition={!!cover}>
                <Then>
                  <Image
                    src={imageUrl(cover, { width: 32 })}
                    alt={board?.title}
                  />
                </Then>
                <Else>
                  <div
                    className={
                      isOnlyUnclassified || board?._icon === "unclassified"
                        ? styles.unorganized
                        : styles.cover
                    }
                  >
                    <HBIcon
                      type={
                        isOnlyUnclassified || board?._icon === "unclassified"
                          ? "unorganized"
                          : "ic_logo"
                      }
                    />
                  </div>
                </Else>
              </If>
            </div>
            <div className={styles.name}>{board ? board?.title : "未整理"}</div>
            <When
              condition={
                board?.is_private &&
                board?.is_private !== 0 &&
                board?.is_private !== 1
              }
            >
              <HBIcon
                type="lock"
                className={styles.boardIcon}
                title="私有画板"
              />
            </When>

            <When condition={board?.extra?.collab}>
              <HBIcon
                type="duoren"
                className={styles.boardIcon}
                title="多人协作画板"
                style={{ marginTop: 1, fontSize: 17 }}
              />
            </When>
          </div>
        </div>
        <div className={styles.operation}>
          <HBButton
            type={buttonType}
            theme={buttonTheme}
            data-board-id={board?.board_id}
            data-gd-click="button_click"
            data-button-name={buttonName}
            data-search-word={searchWord}
            data-pin-detail
            size="small"
          >
            {buttonText}
          </HBButton>
        </div>
      </div>
    </>
  );
}
